import React, { useMemo } from "react";
import {
    TaskStatus as TaskStatusEnum,
    UI_VISIBLE_TASK_STATUSES,
} from "@common/types/task";
import { Picker } from "@design-system/Picker/Picker.lib";
import type { PickerItemData } from "@design-system/Picker/Picker.types";
import { TASK_STATUS_CONFIG } from "./taskStatus.constants";

const ALL_STATUSES: TaskStatusEnum[] = [...UI_VISIBLE_TASK_STATUSES];

const STATUS_ITEMS: Array<PickerItemData<TaskStatusEnum>> = ALL_STATUSES.map(
    (status) => ({ value: status, label: TASK_STATUS_CONFIG[status].tooltip }),
);

const summarizeStatuses = (statuses: readonly TaskStatusEnum[]) => {
    if (statuses.length === ALL_STATUSES.length) {
        return "All statuses";
    }

    if (statuses.length === 1) {
        return TASK_STATUS_CONFIG[statuses[0]].tooltip;
    }

    return `${statuses.length} statuses`;
};

interface TaskStatusMultiSelectProps {
    selectedStatuses: TaskStatusEnum[];
    onChange: (statuses: TaskStatusEnum[]) => void;
    container?: HTMLElement;
}

export const TaskStatusMultiSelect: React.FC<TaskStatusMultiSelectProps> = ({
    selectedStatuses,
    onChange,
    container,
}) => {
    const currentSelectedStatuses = useMemo(
        () => (selectedStatuses.length > 0 ? selectedStatuses : ALL_STATUSES),
        [selectedStatuses],
    );

    const handleValueChange = (statuses: TaskStatusEnum[]) => {
        if (statuses.length === 0) {
            onChange(ALL_STATUSES);
            return;
        }

        onChange(statuses);
    };

    return (
        <Picker.Select
            items={STATUS_ITEMS}
            multiple
            value={currentSelectedStatuses}
            onValueChange={handleValueChange}
            renderValue={summarizeStatuses}
            container={container}
        />
    );
};
